import { render, staticRenderFns } from "./BaseRoleInfo.vue?vue&type=template&id=86e224c8&scoped=true&"
import script from "./BaseRoleInfo.vue?vue&type=script&lang=js&"
export * from "./BaseRoleInfo.vue?vue&type=script&lang=js&"
import style0 from "./BaseRoleInfo.vue?vue&type=style&index=0&id=86e224c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86e224c8",
  null
  
)

export default component.exports